import {
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
    useQuery,
} from "react-query";

import { InstaMart, ISkuIdOption } from "../../utils/api";
import { useAuth } from "../useAuth";

type TUseQueryOptions<
    TQueryFnData,
    TError,
    TData,
    TQueryKey extends QueryKey,
> = Omit<UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>, "queryFn">;

export interface IUseGetInstaMartSkuIdsParameters {
    options?: TUseQueryOptions<any, unknown, ISkuIdOption[], string[]>;
}

export const useGetInstaMartSkuIds = (
    parameters: IUseGetInstaMartSkuIdsParameters = {},
): UseQueryResult<ISkuIdOption[], unknown> => {
    const { options } = parameters;

    const { token } = useAuth();

    if (!token) {
        throw new Error(
            "Cannot fetch InstaMArt SKU IDs without authentication token",
        );
    }

    return useQuery({
        queryKey: options?.queryKey ?? ["instamart-sku-ids"],
        queryFn: async () => {
            const response = await InstaMart.getDistinctSkuIds({ token });
            return response;
        },
        ...options,
    });
};
